<template lang="pug">
    section
        navbar(:expanded="true", :colored="navbar_color")
        div.journey
            family
            origin
            vision
            terroir
            team
</template>

<script>
import Navbar from '@/components/the-navbar'
import Family from '@/components/casa-relvas-family'
import Origin from '@/components/casa-relvas-origin'
import Vision from '@/components/casa-relvas-vision'
import Terroir from '@/components/casa-relvas-terroir'
import Team from '@/components/casa-relvas-team'

// function debounce (fn, delay) {
//     let timeout = null

//     return function () {
//         // console.log('debouncing...')
//         const args = arguments
//         const ctx = this
//         clearTimeout(timeout)
//         timeout = setTimeout(function () { fn.apply(ctx, args) }, delay)
//     }
// }

export default {
    name: 'casa-relvas-view',
    components: { Navbar, Family, Origin, Vision, Terroir, Team },
    data () {
        return {
            player: null,
            silent: false,
            slider: null,
            chapters: [
                {
                    name: 'family',
                    idx: 0,
                    length: 4
                },
                {
                    name: 'origin',
                    idx: 4,
                    length: 11
                },
                {
                    name: 'vision',
                    idx: 15,
                    length: 4
                },
                {
                    name: 'terroir',
                    idx: 19,
                    length: 5
                },
                {
                    name: 'team',
                    idx: 24,
                    length: 5
                }
            ],
            navbar_color: true
        }
    },
    mounted () {
        this.init()
    },
    watch: {
        $route () {
            this.go()
        }
    },
    methods: {
        init () {
            const wrap = document.querySelector('.journey')
            const container = document.querySelector('.journey')
            const fragments = [...container.childNodes]

            fragments.forEach((fragment) => {
                const children = [...fragment.childNodes]
                children.forEach(n => container.appendChild(n))
                container.removeChild(fragment)
            })

            wrap.addEventListener('wheel', this.scroll)
            wrap.addEventListener('scroll', this.findActiveChapter)
            wrap.addEventListener('scroll', this.getElementOnView)
            // wrap.addEventListener('scroll', debounce(this.animate, 500))
            wrap.addEventListener('scroll', this.animate)

            // this.setNavbarColor()

            this.go()
        },

        go () {
            const wrap = document.querySelector('.journey')
            const chapter = this.chapters.find(i => i.name === this.$route.name)

            if (!this.silent) {
                wrap.scrollLeft = chapter.idx * wrap.offsetWidth
            }
            this.silent = false
        },

        setNavbarColor () {
            this.navbar_color = !(this.$route.name === 'team')
        },

        // playing () {
        //     console.log('playing')
        //     const el = document.querySelector('.journey')

        //     if (el.offsetWidth + el.scrollLeft >= el.scrollWidth) {
        //         clearInterval(this.player)
        //         console.log('end journey')
        //     } else {
        //         document.querySelector('.journey').scrollLeft += 3
        //     }
        // },

        scroll (ev) {
            const delta = ev.wheelDelta || -ev.deltaY || ev.originalEvent.wheelDelta
            document.querySelector('.journey').scrollLeft -= delta > 0 ? 25 : -25
        },

        animate () {
            const els = document.querySelectorAll('[data-animate]')

            els.forEach((el) => {
                const bounding = el.getBoundingClientRect()
                const inview = bounding.left + bounding.width * 0.5 <= window.innerWidth

                if (inview && !el.classList.contains(el.dataset.animate)) {
                    el.classList.add(el.dataset.animate)
                    el.classList.remove('chapter-period-fadein')
                }
            })
        },

        findActiveChapter () {
            const scroll = document.querySelector('.journey')
            const chapter = this.chapters.find(i => scroll.scrollLeft >= i.idx * scroll.offsetWidth && scroll.scrollLeft < (i.idx + i.length) * scroll.offsetWidth)
            const idx = this.chapters.findIndex(i => i.name === chapter.name)

            if (chapter.name !== this.$route.name) {
                this.silent = true
                this.$router.push(this.$t('navbar.item_1.subnav.links')[idx].url)
            }
        },

        getElementOnView () {
            const els = document.querySelectorAll('[data-navbar-uncolored]')
            const uncolored = Array.from(els).some((el) => {
                const bounding = el.getBoundingClientRect()
                const inview = bounding.right >= 0 && bounding.right <= window.innerWidth
                return el.hasAttribute('data-navbar-uncolored') && inview
            })
            this.navbar_color = !uncolored
        }
    }
}
</script>

<style lang="stylus">

parallax()
    min-height calc(100vw / 2.13)

    background-size cover
    background-repeat no-repeat
    background-position center

    @media screen and (min-width 1025px)
        background-attachment fixed

vmiddle()
    width 100%
    height 100%
    display flex
    align-items center

.journey
    h2 + h1
        margin-top 1.5rem
    h2 + p
        margin-top 2.750rem

    // scroll-behavior smooth

    @media screen and (min-width 1025px)
        width 100vw
        height 100vh

        display flex
        overflow hidden
        overflow-x auto

.chapter
    @media screen and (min-width 1025px)
        position relative
        width 100vw
        height 100vh

        display inline-block
        flex-shrink 0

    &-intro
        parallax()
        vmiddle()

        @media screen and (max-width 768px)
            height 100vh

    &-banner
        min-height calc(100vw / 2.13)
        parallax()

    &-period
        h1 + p
            margin-top 2rem
        @media screen and (min-width 1025px)
            vmiddle()

        @media screen and (max-width: 768px)
            padding 5px 5px 0px 5px !important
            // padding-right 5px !important

        .&-word
            @media screen and (max-width 1024px)
                font-size 3rem !important

        &-fadein
            @media screen and (min-width 1025px)
                visibility hidden
        &-text
            @media screen and (max-width: 768px)
                padding-top 35px !important
                padding-bottom 35px !important

</style>
